import api from "@/lib/API";

export const fetchInventory = async () => {
  return await api.get(`/inventory?serviceType=Verve`);
};

export const updateInventoryItem = async (id, data) => {
  return await api.patch(`/inventory/${id}`, data);
};

export const addItem = async (data) => {
  return await api.post('/inventory', data);
};

export const createPurchase = async (data) => {
  return await api.post('/final-inventory/purchases', data);
};

export const fetchPurchases = async () => {
  return await api.get(`/final-inventory/purchases?serviceType=Verve`);
};

export const fulfillQueuePurchase = async (id, data) => {
  return await api.put(`/inventory/purchases/${id}/fulfill-queue`, data);
};

export const fetchOpeningStocks = async () => {
  return await api.get(`/inventory/opening-stock?serviceType=Verve`);
};

export const createOpeningStock = async (data) => {
  return await api.post('/inventory/opening-stock', data);
};

export const updateOpeningStock = async (id, data) => {
  return await api.put(`/inventory/opening-stock/${id}`, data);
};

export const deleteOpeningStock = async (id) => {
  return await api.delete(`/inventory/opening-stock/${id}`);
};

// ── Verve Opening Stock ──────────────────
export const fetchVerveOpeningStocks = async () => {
  return await api.get(`/inventory/purchases?serviceType=Verve&isOpenStock=true`);
};

export const createVerveOpeningStock = async (data) => {
  return await api.post('/inventory/opening-stock', data);
};

export const updateVerveOpeningStock = async (id, data) => {
  return await api.put(`/inventory/opening-stock/${id}`, data);
};

export const deleteVerveOpeningStock = async (id) => {
  return await api.delete(`/inventory/opening-stock/${id}`);
};



export const fetchPurchaseByInvoice = async (invoiceNo) => {
  return await api.get(`/final-inventory/purchases/by-invoice/${encodeURIComponent(invoiceNo)}`);
};

export const updatePurchase = async (id, data) => {
  return await api.patch(`/final-inventory/purchases/${id}`, data);
};

// ── Material Requests ───────────────────────────────────────────────────────────
export const fetchMaterialRequests = async (params = {}) => {
  const { serviceType = 'verve', limit = 50000, ...rest } = params;
  return await api.get(`/inventory/material-requests?serviceType=${serviceType}&limit=${limit}`, { params: rest });
};

export const createMaterialRequest = async (data) => {
  return await api.post('/inventory/material-requests', data);
};

export const updateMaterialRequest = async (id, data) => {
  return await api.put(`/inventory/material-requests/${id}`, data);
};

export const deleteMaterialRequest = async (id) => {
  return await api.delete(`/inventory/material-requests/${id}`);
};

// ── Material Returns ────────────────────────────────────────────────────────────
export const fetchMaterialReturns = async () => {
  return await api.get(`/inventory/material-returns?serviceType=Verve`);
};

export const createMaterialReturn = async (data) => {
  return await api.post('/inventory/material-returns', data);
};

export const updateMaterialReturn = async (id, data) => {
  return await api.put(`/inventory/material-returns/${id}`, data);
};

export const deleteMaterialReturn = async (id) => {
  return await api.delete(`/inventory/material-returns/${id}`);
};

// ── Purchase Returns ────────────────────────────────────────────────────────────
export const fetchPurchaseReturns = async () => {
  return await api.get(`/final-inventory/purchase-returns?serviceType=Verve`);
};

export const createPurchaseReturn = async (data) => {
  return await api.post('/final-inventory/purchase-returns', data);
};

export const updatePurchaseReturn = async (id, data) => {
  return await api.put(`/final-inventory/purchase-returns/${id}`, data);
};

export const deletePurchaseReturn = async (id) => {
  return await api.delete(`/final-inventory/purchase-returns/${id}`);
};

// ── Sale Returns ────────────────────────────────────────────────────────────────
export const fetchSaleReturns = async () => {
  try { return await api.get(`/inventory/sale-returns?serviceType=Verve`); } catch(e) { return { data: { saleReturns: [] } }; }
};

export const createSaleReturn = async (data) => {
  return await api.post('/inventory/sale-returns', data);
};

export const updateSaleReturn = async (id, data) => {
  return await api.put(`/inventory/sale-returns/${id}`, data);
};

export const deleteSaleReturn = async (id) => {
  return await api.delete(`/inventory/sale-returns/${id}`);
};

// ── Sales ───────────────────────────────────────────────────────────────────────
export const fetchSales = async () => {
  try { return await api.get(`/inventory/sales?serviceType=Verve`); } catch(e) { return { data: { sales: [] } }; }
};

export const deleteItem = async (id) => {
  return await api.delete(`/inventory/${id}`);
};

export const updateRequestStatus = async (id, status) => {
  return await api.patch(`/inventory/material-requests/${id}/status`, { status });
};

export const ownerApproveRequest = async (id) => {
  return await api.put(`/material-requests/${id}/owner-approve`);
};



export const getEmptyItem = (serviceType) => ({
  name: "",
  category: "Kitchen Cabinets",
  unit: "piece",
  availableQty: 0,
  minQty: 0,
  unitPrice: 0,
  supplier: "",
  sku: "",
  itemCode: "",
  brand: "",
  hsnCode: "",
  type: "Stockable",
  description: "",
  serviceType: serviceType || "verve",
  taxP: 0,
  invoiceNo: "",
  invoiceDate: "",
  businessUnit: "",
  store: "",
  baseAmount: 0,
  discount: 0,
  gstAmount: 0,
  netBill: 0,
  chargeAmount: 0,
  adjustments: 0,
  netPayment: 0,
  items: []
});

export const CATEGORIES = {
  verve: ["Kitchen Cabinets", "Shutters", "Hardware & Fittings", "Carcase", "Appliances", "Accessories", "Countertops"]
};

export const UNITS = ["piece", "set", "ton", "meter", "kit", "box", "roll", "litre", "kg"];

export const inventoryService = {
  getInventory: fetchInventory,
  fetchInventory,
  updateInventoryItem,
  addItem,
  createPurchase,
  fetchPurchases,
  fetchOpeningStocks,
  createOpeningStock,
  updateOpeningStock,
  deleteOpeningStock,
  fetchVerveOpeningStocks,
  createVerveOpeningStock,
  updateVerveOpeningStock,
  deleteVerveOpeningStock,
  fetchPurchaseByInvoice,
  updatePurchase,
  createMaterialReturn,
  deleteItem,
  fetchMaterialRequests,
  updateRequestStatus,
  ownerApproveRequest,
  fetchMaterialReturns,
  fetchSales,
  fetchPurchaseReturns,
  fetchSaleReturns,
  createPurchaseReturn
};
